import React from 'react';
import { connect } from 'react-redux';

import NowPortalOrderFilter from './component/NowPortalOrderFilter';
import { PageTitle } from '../../../components/Common/PageTitle';
import { EnumPage } from '../../../constants/enum';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import {
  changeFilters,
  changeTableActivePage,
  changeTablePageSize,
  closeDialogGeneric,
  openDialogGeneric,
} from '../../../redux/genericAction';
import {
  getListOrderNowPortal,
  getListStoreNowPortal,
  getProfileNowPortal,
} from './actions';
import { trans } from '../../../localization';
import NowPortalOrderTable from './component/NowPortalOrderTable';

import './NowPortalOrder.scss';
import Loading from '../../../components/Loading/Loading';

class NowPortalOrder extends React.Component {
  componentDidMount() {
    const {
      getListStoreNowPortalConnect,
      getProfileNowPortalConnect,
    } = this.props;
    getListStoreNowPortalConnect();
    getProfileNowPortalConnect();
  }

  render() {
    const {
      metadata,
      order,
      openDialogGenericConnect,
      changeTableActivePageConnect,
      changeTablePageSizeConnect,
      handleChangeFiltersConnect,
      getListOrderNowPortalConnect,
    } = this.props;
    const { filters, table } = order;

    if (!order.stores) {
      return <Loading loading />;
    }

    return (
      <div className="order-management-now-ship-wrapper now-portal-order">
        <PageTitle title={trans('menu_portal_transaction_history')} />
        <NowPortalOrderFilter
          metadata={metadata}
          filters={filters}
          handleChangeFilters={handleChangeFiltersConnect}
          handleSearch={getListOrderNowPortalConnect}
          stores={order.stores}
        />
        <NowPortalOrderTable
          metadata={metadata}
          table={table}
          storeMapping={order.storeMapping}
          changeActivePage={changeTableActivePageConnect}
          changePageSize={changeTablePageSizeConnect}
          getList={getListOrderNowPortalConnect}
          openOrderDetailModal={openDialogGenericConnect}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  order: state.portal.order,
  metadata: state.app.nowPortalMetadata,
});

const PAGE = EnumPage.NOW_PORTAL_TRANSACTION_HISTORY.id;
const mapDispatchToProps = {
  setGeneralErrorConnect: setGeneralError,
  openDialogGenericConnect: openDialogGeneric.bind(null, PAGE),
  closeDialogGenericConnect: closeDialogGeneric.bind(null, PAGE),
  changeTableActivePageConnect: changeTableActivePage.bind(null, PAGE),
  changeTablePageSizeConnect: changeTablePageSize.bind(null, PAGE),
  handleChangeFiltersConnect: changeFilters.bind(null, PAGE),
  getListOrderNowPortalConnect: getListOrderNowPortal,
  getListStoreNowPortalConnect: getListStoreNowPortal,
  getProfileNowPortalConnect: getProfileNowPortal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NowPortalOrder);



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalOrder/NowPortalOrder.jsx